var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.errorsItems)?_c('div',{staticClass:"pb-2 pl-0 pr-2"},_vm._l((_vm.errorsItems),function(errorsItem,index){return _c('p',{key:index,staticClass:"pa-0 ma-0 red--text"},[_vm._v(_vm._s(errorsItem))])})):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }